import { useLocation, useNavigate } from 'react-router-dom'

import { LoginForm } from '@forbiz/web-kit'

import { Footer } from '../components/Footer.js'

/**
 * 기업·업체 로그인. 공유 LoginForm에 이동만 얹는다.
 * 여기서는 역할 제한을 두지 않는다 — 운영자가 로그인하면 RequireAuth의 역할 가드가
 * 받아 안내 화면(WrongAppNotice)으로 보낸다. (LoginForm의 allowedRoles로 막으면
 * 로그인 직후 RedirectIfAuthed가 먼저 걸려 에러 문구가 안 뜬 채 튕겨, 이유를 못 보여준다.)
 *
 * 세션 만료로 튕겨 온 경우 RequireAuth가 원래 경로를 state.from에 담아 준다 →
 * 재로그인 후 그 자리로 돌려보낸다(BIZ-30). 없으면 홈으로.
 */
export function LoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const from = (location.state as { from?: { pathname?: string; search?: string } } | null)?.from
  const dest = from?.pathname ? `${from.pathname}${from.search ?? ''}` : '/'

  // 사업자 정보는 공용 Footer로 노출한다(단일 출처). 로그인 전 공개 페이지라 나비 링크는
  // 끄고(showNav=false, auth로 튕기는 죽은 링크 방지), 카카오 채널 검수자가 클릭 없이 바로
  // 확인하도록 펼쳐 둔다(bizOpen). LoginForm이 100vh를 채우므로 Footer는 그 아래로 흐른다.
  return (
    <>
      <LoginForm
        subtitle="기업 경조사 화환 주문 관리"
        forgotPasswordHref="/forgot-password"
        signupHref="/signup"
        onSuccess={() => navigate(dest, { replace: true })}
        // 알림톡 '주문 보기' 등 딥링크로 온 비로그인 사용자에게 맥락을 준다(BIZ-30의 복귀와 짝).
        notice={from?.pathname ? '로그인하면 보시던 페이지로 바로 이동해요' : undefined}
      />
      <Footer showNav={false} bizOpen />
    </>
  )
}
